<div class="row">
    <div class="col-md-12 pl-4">
        <yt-fw-default-update-buttons #defaultUpdateButtons (AddItemClicked)="handleAddItemEvent()">

        </yt-fw-default-update-buttons>
    </div>
  </div>
  <yt-zaposleni-update #baseUpdate></yt-zaposleni-update>